<template>
  <div>
    <div class="form_progress">
      <div class="tick">
        <div 
          class="marker part_1 completex"
          :class="{'complete': isPage1Valid, 'active': currentPage == 1}"
        ></div>
      </div>
      <div class="tick">
        <div 
          class="marker part_2"
          :class="{'complete': currentPage > 2, 'active': currentPage == 2}"
        ></div>
      </div>
      <div class="tick">
        <div 
          class="marker part_3"
          :class="{'complete': currentPage > 3, 'active': currentPage == 3}"
        ></div>
      </div>
      <div class="tick">
        <div 
          class="marker part_4"
          :class="{'complete': currentPage > 3, 'active': currentPage == 4}"
        ></div>
      </div>
    </div>
    <fieldset v-if="currentPage == 1">
      <legend class="interface-form__legend">
        <h2>
          Part 1 - Tell us about your image request
        </h2>
      </legend>
      <label>
        Title
      </label>
      <input 
        v-model="data.post_title"
        type="text" 
        name="post_title" 
        placeholder="Insert the title of the book or name of feature / project"
      />
      <br />
      <br />
      <label>
        Description
      </label>
      <textarea 
        v-model="data.post_message"
        name="post_message"
        row="10" 
        placeholder="What is the project about. What sort of picture would you like to see."
      ></textarea>
    </fieldset>
    <fieldset v-if="currentPage == 2">
      <legend class="interface-form__legend">
        <h2>
          Part 2 - Show us a sample image
        </h2>
        (optional- click next if you do not want to insert an image)
      </legend>
      <label></label>
      <article class="uploader_wrapper">
        <div class="image_details">
          <div v-if="data.sample">
            <img
              v-if="file"
              :src="file.previewImage" style="width:auto;height:200px;"
            />
            <img 
              v-else
              :src="'//milim-interface.s3.amazonaws.com/samples/' + data.sample" style="width:auto;height:200px;"
            />
            <button class="button inline" @click="handleClickRemoveSampleImage">
              Remove sample image
            </button>
          </div>
          <interface-upload-box
            v-if="!data.sample"
            doc-type="interface" 
            doc-group="group1"
            doc-file-types="image/jpeg"
            @select="handleSelect"
           />
           <div class="instructions">
            <p>
              When uploading an image please ensure that:
            </p>
            <ul>
              <li>Only 1 image per Image Request</li>
              <li>Upload a jpeg file</li>
              <li>Maximum compressed file size is 5MB</li>
            </ul>
          </div>
        </div>
      </article>
    </fieldset>
    <fieldset v-if="currentPage == 3">
      <legend class="interface-form__legend">
        <h2>
          Part 3 - Tell us your deadline for recieving images
        </h2>
      </legend>
			<div class="date_output">
				<span>{{ post_deadline }}</span><br>at midnight UK time
			</div>
			<label for="post_deadline"></label>
			<div class="form_range_ticks">
				<div class="tick t1_7">
					<div class="marker">
						<span>Today</span>
					</div>
				</div>
				<div class="tick t1_7">
					<div class="marker">
						<span>Tomorrow</span>
					</div>
				</div>
				<div class="tick t1_7">
					<div class="marker">
						<span>2 days</span>
					</div>
				</div>
				<div class="tick t1_7">
					<div class="marker">
						<span>3 days</span>
					</div>
				</div>
				<div class="tick t1_7">
					<div class="marker">
						<span>4 days</span>
					</div>
				</div>
				<div class="tick t1_7">
					<div class="marker">
						<span>5 days</span>
					</div>
				</div>
				<div class="tick t1_7">
					<div class="marker">
						<span>6 days</span>
					</div>
				</div>
				<div class="tick t1_7">
					<div class="marker">
						<span>7 days</span>
					</div>
				</div>
			</div>
			<input 
        v-model="data.post_deadline"
        type="range" 
        min="0" 
        max="7" 
        id="post_deadline" 
        name="post_deadline" 
        step="1" 
        list="datesettings"
        @change="handleChange"
      />
			<datalist id="datesettings">
				<option>0</option>
				<option>1</option>
				<option>2</option>
				<option>3</option>
				<option>4</option>
				<option>5</option>
				<option>6</option>
				<option>7</option>
			</datalist>
		</fieldset>
    <fieldset v-if="currentPage == 4">
      <legend class="interface-form__legend">
        <h2>
          Part 4 - Tell us what the image will be used for
        </h2>
      </legend>
			<!-- <input 
        type="hidden" 
        name="intended_use" value="" /> -->
			<div class="choice_list grid-x grid-margin-x">
				<div class='cell text-center small-4 medium-auto'>
					<a 
            href="#!" 
            class="choice_bt"
            :class="{'selected': data.intended_use == 'advertising'}"
            @click="handleClickIntendedUse('advertising')"
          >
            <svg width="78px" height="60px" viewBox="0 0 78 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>ad</title> <g id="PAGES" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="INTERFACE-/-NEW-REQUEST-4" transform="translate(-645.000000, -629.000000)" fill="#000000" fill-rule="nonzero"> <g id="ad" transform="translate(645.000000, 629.000000)"> <path d="M8.58564935,40.3581175 C5.88545455,43.0652432 3.59918182,43.8725251 0,42.9681266 L8.55977922,56.8831169 C9.39085714,53.5629425 11.1952987,51.6995175 15.0434805,50.8588517 L64.6753247,39.5326263 L44.1894156,6.23376623 L8.58564935,40.3581175 L8.58564935,40.3581175 Z" id="Path"></path> <path d="M45.1948052,49.0909091 L43.6919894,55.3405894 C43.3894955,56.4559715 42.4337432,57.3293923 41.2173313,57.6156147 L31.7177336,59.8994922 C30.543156,60.1798131 29.2945638,59.8640833 28.4417883,59.0732833 L23.3766234,54.0216059 L28.5415469,52.8560612 L30.6203885,55.1281357 C31.1867601,55.6504178 32.0105735,55.8599208 32.7893346,55.6769745 L37.931732,54.4229074 C38.7426733,54.2340596 39.3766234,53.6527626 39.5761407,52.9121254 L40.0974601,50.2387493 L45.1948052,49.0909091 Z" id="Path"></path> <polygon id="Path" points="73.2467532 14.6699021 64.7351253 19.4805195 62.3376623 15.7167259 70.8556327 10.9090909"></polygon> <polygon id="Path" points="59.599183 10.9090909 55.3246753 9.00540819 59.6215962 0 63.8961039 1.90677311"></polygon> <polygon id="Path" points="77.6464449 29.6103896 67.012987 29.1152548 67.2819783 24.9350649 77.9220779 25.4330453 77.6464449 29.6103896"></polygon> </g> </g> </g> </svg>
						<span>Advertising</span>
					</a>
				</div>
				<div class='cell text-center small-4 medium-auto'>
					<a 
            href="#!" 
            class="choice_bt"
            :class="{'selected': data.intended_use == 'editorial'}"
            @click="handleClickIntendedUse('editorial')"
          >
						<svg width="72px" height="60px" viewBox="0 0 72 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>ed</title> <g id="PAGES" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="INTERFACE-/-NEW-REQUEST-4" transform="translate(-886.000000, -629.000000)" fill="#000000" fill-rule="nonzero"> <g id="ed" transform="translate(886.000000, 629.000000)"> <path d="M21,39 L60,39 L60,42 L21,42 L21,39 Z M33,27 L33,36 L48,36 L48,27 L33,27 Z M30,27 L21,27 L21,30 L30,30 L30,27 Z M21,36 L30,36 L30,33 L21,33 L21,36 Z M60,33 L51,33 L51,36 L60,36 L60,33 Z M39.147,13.281 L39.147,12.093 L35.502,12.093 L35.502,17.916 L39.267,17.916 L39.267,16.728 L36.927,16.728 L36.927,15.51 L39.021,15.51 L39.021,14.331 L36.927,14.331 L36.927,13.281 L39.147,13.281 L39.147,13.281 Z M43.335,14.064 L44.049,17.916 L45.549,17.916 L47.052,12.093 L45.606,12.093 L44.859,16.053 L44.145,12.093 L42.669,12.093 L41.859,16.128 L41.139,12.093 L39.624,12.093 L41.004,17.916 L42.522,17.916 L43.335,14.064 Z M49.038,16.812 C48.591,16.812 48.066,16.683 47.64,16.464 L47.568,16.425 L47.274,17.619 L47.319,17.643 C47.625,17.817 48.273,18 48.96,18 C50.703,18 51.324,17.016 51.324,16.17 C51.324,15.354 50.841,14.796 49.803,14.412 C49.041,14.124 48.789,13.977 48.789,13.671 C48.789,13.377 49.089,13.188 49.551,13.188 C49.959,13.188 50.349,13.278 50.715,13.452 L50.784,13.485 L51.105,12.315 L51.06,12.294 C50.625,12.099 50.127,12 49.575,12 C48.249,12 47.358,12.717 47.358,13.779 C47.358,14.565 47.901,15.153 48.963,15.522 C49.644,15.765 49.875,15.954 49.875,16.263 C49.875,16.614 49.569,16.812 49.038,16.812 L49.038,16.812 Z M33.063,17.916 L34.518,17.916 L34.518,12.093 L33.204,12.093 L33.204,15.66 L31.281,12.093 L29.676,12.093 L29.676,17.916 L30.99,17.916 L30.99,13.935 L33.063,17.916 Z M60,21 L21,21 L21,24 L60,24 L60,21 Z M60,27 L51,27 L51,30 L60,30 L60,27 Z M9,0 L9,51.597 C9,53.91 6,53.91 6,51.597 L6,6 L0,6 L0,53.94 C0,57.285 2.715,60 6.06,60 L65.934,60 C69.285,60 72,57.288 72,53.94 L72,0 L9,0 L9,0 Z M66,48 L15,48 L15,6 L66,6 L66,48 Z" id="Shape"></path> </g> </g> </g> </svg>
						<span>Editorial</span>
					</a>
				</div>
				<div class='cell text-center small-4 medium-auto'>
					<a 
            href="#!" 
            class="choice_bt"
            :class="{'selected': data.intended_use == 'book cover'}"
            @click="handleClickIntendedUse('book cover')"
          >
						<svg width="72px" height="60px" viewBox="0 0 72 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>book</title> <g id="PAGES" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="INTERFACE-/-NEW-REQUEST-4" transform="translate(-1123.000000, -630.000000)" fill="#000000" fill-rule="nonzero"> <g id="book" transform="translate(1123.000000, 630.000000)"> <path d="M36,8.118 C27.186,2.628 13.752,0.42 0,0 L0,53.142 C11.811,53.502 23.385,55.185 32.001,59.127 C34.539,60.291 37.452,60.291 40.002,59.127 C48.618,55.185 60.189,53.502 72,53.142 L72,0 C58.248,0.42 44.814,2.628 36,8.118 Z M6,47.43 L6,6.318 C21.471,7.485 28.581,10.707 33,13.32 L33,52.824 C28.425,51.186 18.852,48.312 6,47.43 L6,47.43 Z M66,47.43 C53.151,48.309 43.575,51.186 39,52.827 L39,13.314 C43.359,10.731 50.49,7.488 66,6.318 L66,47.43 Z M60,16.788 C53.742,17.724 46.647,19.857 42,21.804 L42,18.612 C47.004,16.746 53.643,14.667 60,13.734 L60,16.788 L60,16.788 Z M60,25.953 C53.643,26.886 47.004,28.965 42,30.831 L42,34.023 C46.647,32.076 53.742,29.94 60,29.004 L60,25.953 Z M60,19.86 C53.643,20.793 47.004,22.872 42,24.738 L42,27.93 C46.647,25.983 53.742,23.847 60,22.911 L60,19.86 Z M60,38.139 C53.643,39.072 47.004,41.151 42,43.017 L42,46.209 C46.647,44.262 53.742,42.126 60,41.19 L60,38.139 L60,38.139 Z M60,32.046 C53.643,32.979 47.004,35.058 42,36.924 L42,40.116 C46.647,38.169 53.742,36.033 60,35.097 L60,32.046 Z M12,13.734 C18.357,14.667 24.996,16.746 30,18.612 L30,21.804 C25.353,19.857 18.258,17.721 12,16.788 L12,13.734 L12,13.734 Z M12,29.004 C18.258,29.94 25.353,32.073 30,34.023 L30,30.831 C24.996,28.965 18.357,26.886 12,25.953 L12,29.004 Z M12,22.911 C18.258,23.847 25.353,25.98 30,27.93 L30,24.738 C24.996,22.872 18.357,20.79 12,19.86 L12,22.911 Z M12,41.19 C18.258,42.126 25.353,44.259 30,46.209 L30,43.017 C24.996,41.151 18.357,39.072 12,38.139 L12,41.19 Z M12,35.097 C18.258,36.033 25.353,38.166 30,40.116 L30,36.924 C24.996,35.058 18.357,32.979 12,32.046 L12,35.097 Z" id="Shape"></path> </g> </g> </g> </svg>
						<span>Book cover</span>
					</a>
				</div>
				<div class='cell text-center small-4 medium-auto'>
					<a 
            href="#!" 
            class="choice_bt"
            :class="{'selected': data.intended_use == 'products'}"
            @click="handleClickIntendedUse('products')"
          >
						<svg width="72px" height="60px" viewBox="0 0 72 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>electronic</title> <g id="PAGES" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="INTERFACE-/-NEW-REQUEST-4" transform="translate(-1598.000000, -629.000000)" fill="#000000" fill-rule="nonzero"> <g id="electronic" transform="translate(1598.000000, 629.000000)"> <path d="M66,0 L6,0 L6,39 L66,39 L66,0 Z M60,33 L12,33 L12,6 L60,6 L60,33 Z M66,42 L6,42 L0,60 L72,60 L66,42 Z M29.316,57 L30.714,54 L41.286,54 L42.684,57 L29.316,57 L29.316,57 Z" id="Shape"></path> </g> </g> </g> </svg>
						<span>Products</span>
					</a>
				</div>
				<div class='cell text-center small-4 medium-auto'>
					<a 
            href="#!" 
            class="choice_bt"
            :class="{'selected': data.intended_use == 'electronic'}"
            @click="handleClickIntendedUse('electronic')"
          >
						<svg width="45px" height="60px" viewBox="0 0 45 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>product</title> <g id="PAGES" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="INTERFACE-/-NEW-REQUEST-4" transform="translate(-1375.000000, -629.000000)" fill="#000000"> <g id="product" transform="translate(1375.000000, 629.000000)"> <path d="M5.625,43.305 L0,40.2525 L5.585,32.585 L0,27.685 L11.7825,21.28 C12.2925,21.8575 12.8075,22.54 13.2925,23.2975 L4.3325,28.1675 L7.285,30.76 L14.93,26.545 C15.2275,27.33 15.47,28.1475 15.635,28.9875 L7.4825,33.49 L22.5275,41.2625 L37.5,33.5 L29.62,29.1375 C29.7725,28.27 29.98,27.47 30.24,26.7175 L37.5725,30.755 L40.6575,28.0175 L31.9075,23.38 C32.365,22.6925 32.8775,22.03 33.4425,21.3725 L45,27.495 L39.3475,32.515 L39.375,32.53 L45,40.2325 L39.375,43.2925 L39.375,51.01 L22.5,60 L5.625,51.01 L5.625,43.305 L5.625,43.305 Z M23.74,43.07 L23.74,56.5125 L36.8775,49.515 L36.8775,44.65 L28.125,49.4125 L23.74,43.07 L23.74,43.07 Z M8.1225,44.66 L8.1225,49.515 L21.2425,56.505 L21.2425,43.0725 L16.875,49.4125 L8.1225,44.66 Z M3.6925,39.42 L16.0925,46.15 L18.84,42.165 L6.3825,35.7275 L3.6925,39.42 L3.6925,39.42 Z M26.1625,42.1875 L28.9025,46.15 L41.305,39.405 L38.6225,35.7275 L26.1625,42.1875 L26.1625,42.1875 Z M23.1825,34.9 L21.88,34.9 C21.54,34.9 21.21,34.785 20.985,34.5825 L19.255,33.445 L25.8075,33.445 L24.0775,34.5825 C23.855,34.785 23.525,34.9 23.1825,34.9 L23.1825,34.9 Z M25.87,31.99 L19.2325,31.99 C18.83,31.99 18.505,31.6675 18.505,31.265 C18.505,30.8625 18.83,30.5375 19.2325,30.5375 L25.87,30.5375 C26.2725,30.5375 26.5975,30.8625 26.5975,31.265 C26.5975,31.6675 26.2725,31.99 25.87,31.99 Z M26.5875,29.0825 L18.475,29.0825 C18.475,23.34 13.795,20.855 13.795,15.665 C13.795,10.25 18.16,7.27 22.5275,7.27 C26.8975,7.27 31.27,10.255 31.27,15.665 C31.27,20.855 26.59,23.26 26.5875,29.0825 L26.5875,29.0825 Z M24.335,26.59 C24.805,24.205 25.895,22.3675 26.88,20.7 C27.94,18.915 28.7725,17.5025 28.7725,15.665 C28.7725,11.79 25.63,9.7625 22.5275,9.7625 C19.43,9.7625 16.29,11.79 16.29,15.665 C16.29,17.5125 17.1325,18.945 18.1975,20.7525 C19.1775,22.4125 20.2525,24.2425 20.7275,26.59 L24.335,26.59 L24.335,26.59 Z M10.9425,15.7875 L6.5125,15.7875 L6.5125,13.295 L11.0575,13.295 C10.96,13.8425 10.91,14.4075 10.91,14.98 L10.9425,15.7875 L10.9425,15.7875 Z M38.55,15.7875 L34.1475,15.7875 L34.1825,14.98 C34.1825,14.4075 34.1325,13.8425 34.0325,13.295 L38.55,13.295 L38.55,15.7875 L38.55,15.7875 Z M13.5925,8.26 C13.025,8.8775 12.5325,9.555 12.1325,10.2825 L8.535,7.73 L9.98,5.6975 L13.5925,8.26 L13.5925,8.26 Z M31.49,8.2475 L35.0825,5.6975 L36.5275,7.73 L32.9525,10.2675 C32.55,9.5425 32.0575,8.865 31.49,8.2475 Z M18.24,5.1975 C17.445,5.485 16.6925,5.85 15.9925,6.28 L14.0625,2.3425 L16.305,1.2475 L18.24,5.1975 Z M26.8275,5.1875 L28.76,1.2475 L31,2.3425 L29.0775,6.2675 C28.3775,5.8375 27.625,5.4725 26.8275,5.1875 Z M23.78,4.51 C23.375,4.47 22.9625,4.45 22.545,4.45 C22.12,4.45 21.6975,4.4725 21.2825,4.5125 L21.2825,0 L23.78,0 L23.78,4.51 Z" id="Shape"></path> </g> </g> </g> </svg>
						<span>Electronic</span>
					</a>
				</div>
			</div>
		</fieldset>
    <nav class="interface-form__nav">
      <button 
        class="button inline"
        @click="handleClickBack"
        :disabled="currentPage == 1"
      >
        Back
      </button>
      <button 
        class="align_rightx button inline"
        @click="handleClickNext"
        :disabled="isNextDisabled"
      >
        Next
      </button>
      <button 
        class="align_right button inline"
        @click="handleClickDraft()"
        :disabled="!isValid || !isInitial"
      >
        Save as draft
      </button>
      <button 
        class="align_right button inline"
        @click="handleClickPublish()"
        :disabled="!isValid || !isInitial"
      >
        Publish
      </button>
    </nav>
  </div>
</template>

<script>
import InterfaceUploadBox from './InterfaceUploadBox.vue';

const STATE_INITIAL = 0,
  STATE_LOADING = 1,
  STATE_SAVING = 2,
  STATE_SAVED = 3,
  STATE_FAILED = 4; 

export default {
  name: 'ImageRequestForm',
  props: {
    postId: Number,
  },
  components: {
    InterfaceUploadBox,
  },
  data: function(){
    return {
      currentState: null,
      data: {
        post_title: null,
        post_message: null,
        post_deadline: 1,
        sample: null,
        sample_base64: null,
        intended_use: null,
      },
      currentPage: 0,
      post_deadline: null,
      file: null,
    }
  },
  computed: {
    isInitial: {
        get () {
            return this.currentState === STATE_INITIAL;
        },
    },
    isLoading: {
        get () {
            return this.currentState === STATE_LOADING;
        },
    },
    isSaving: {
        get () {
            return this.currentState === STATE_SAVING;
        },
    },
    isSaved: {
        get () {
            return this.currentState === STATE_SAVED;
        },
    },
    isFailed: {
        get () {
            return this.currentState === STATE_FAILED;
        },
    },
    isValid: {
        get () {
            return (this.currentPage == 4) && (this.isPage1Valid) && (this.isPage4Valid);
        },
    },
    isPage1Valid: {
        get () {
            return (this.data.post_title !== null && this.data.post_title !== '') && (this.data.post_messages !== null && this.data.post_message !== '');
        },
    },
    isPage4Valid: {
        get () {
            return (this.data.intended_use !== null && this.data.intended_use !== '');
        },
    },
    isNextDisabled: {
        get () {
          if (this.currentPage == 1) {
            return !this.isPage1Valid;
          } else if (this.currentPage == 4) {
            return true;
          } else {
            return false;
          }
        },
    },
  },
  created: function () {
    this.currentState = STATE_INITIAL;
    this.currentPage = 1;
    this.handleChange();
    if (this.postId) {
      this.fetchRequest();
    }
  },
  methods: {
    handleClickBack() {
      this.currentPage--;
    },
    handleClickNext() {
      this.currentPage++;
    },
    handleClickIntendedUse(newIntendedUse) {
      this.data.intended_use = newIntendedUse;
    },
    handleClickPublish() {
      this.data.post_status = 'published';
      this.save();
    },
    handleClickDraft() {
      this.data.post_status = 'draft';
      this.save();
    },
    handleClickRemoveSampleImage() {
      this.file = null;
      this.data.sample = null;
      this.data.sample_base64 = null;
    },
    handleSelect(file) {
      this.file = file;
      this.data.sample = file.name;
      this.data.sample_base64 = file.previewImage;
    },
    handleChange() {
      // set deadline date output
      const dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      const monthNames = [
        "January", 
        "February", 
        "March",
        "April", 
        "May", 
        "June", 
        "July",
        "August", 
        "September", 
        "October",
        "November", 
        "December"
      ];
      
      var date = new Date();
      var new_date = new Date(date.getTime() + this.data.post_deadline * 24 * 60 * 60 * 1000);
      var dayIndex = new_date.getDay();
      var day = new_date.getDate();
      var monthIndex = new_date.getMonth();
      var year = new_date.getFullYear();
      var d = dayNames[dayIndex] + " - " + day + ' ' + monthNames[monthIndex] + ' ' + year;
      // console.log(d);
      this.post_deadline = d;
      // $('.date_output span').html(d);
    },
    save() {
      const self = this;
      this.currentState = STATE_SAVING;

      if (this.isInitial) {
        console.log('isInitial');
        console.log(this.currentState);
      } else {
        console.log('not isInitial');
      }
      // console.log(this.data);
      // console.log(window.baseUrl);
      this.axios.post(window.baseUrl + 'api/request', this.data).then(response => {
        // console.log(response.data.responseResult.data);
        // console.log(response.data.responseResult);
        // self.notes = response.data.responseResult.data;
        self.onSaveComplete();
      });
    },
    onSaveComplete() {
      const self = this;
      this.currentState = STATE_SAVED;
      // Set redirect 
      setTimeout(function(){ 
        if (self.data.post_status == 'published') {
          window.location.replace(window.baseUrl + 'requests');
        } else {
          window.location.replace(window.baseUrl + 'drafts');
        }
      }, 50);
    },
    fetchRequest() {
      const self = this;
      this.currentState = STATE_LOADING;
      this.axios.get(window.baseUrl + 'api/request', { params:  { post_id: this.postId } }).then(response => {
        // console.log(response.data.responseResult.data);
        // console.log(response.data.responseResult);
        self.data = response.data.responseResult.data;
        self.data.sample_base64 = null,
        self.onFetchRequestComplete();
      });
    },
    onFetchRequestComplete() {
      this.currentState = STATE_INITIAL;
    },
  }
}
</script>
